export const WHATSAPP_NUMBER = "919211949414";
export const WHATSAPP_DISPLAY = "+91-9211949414";
export const PHONE_SECONDARY = "+91-9871137368";
export const CONTACT_EMAIL = "Info@sharpinhealthcareservices.com";

export const openWhatsApp = (message) => {
  window.open(
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`,
    "_blank",
    "noopener,noreferrer"
  );
};

export const DEFAULT_WA_MESSAGE =
  "Hello Sharpin Healthcare Services, I would like to inquire about homecare services for my family.";

export const RAZORPAY_PAYMENT_PAGE = "https://razorpay.me/@sharpinhealthcareservices";

export const openPaymentPage = () => {
  window.open(RAZORPAY_PAYMENT_PAGE, "_blank", "noopener,noreferrer");
};
